import defaultImage from '../../../image/placeholder_group_o.jpg';
import Platform from './Platform';
import { PLATFORMS } from '../constants';

export default function getImageProp(image) {
    if (!image) return defaultImage;
    return Platform.OS === PLATFORMS.web || image.uri ? image : { uri: image };
}
